import { apiService } from './index';

export const storeManagerService = {
  // Receive package
  receivePackage: (deliveryId, data) => {
    return apiService.post(`/store-manager/deliveries/${deliveryId}/receive`, data);
  },

  // Report missing items
  reportMissingItems: (deliveryId, data) => {
    return apiService.post(`/store-manager/deliveries/${deliveryId}/missing-items`, data);
  },

  // Update item status
  updateItemStatus: (itemId, data) => {
    return apiService.patch(`/store-manager/items/${itemId}/status`, data);
  },

  // Manage dresses in store
  manageDresses: (data) => {
    return apiService.post('/store-manager/dresses/manage', data);
  },

  // Payment reminders (admin-visible; used by Store Manager UI)
  getReminders: (params = {}) => {
    const query = new URLSearchParams(params).toString();
    return apiService.get(`/admin/reminders${query ? `?${query}` : ''}`);
  },
  scheduleReminders: (orderId) => {
    return apiService.post(`/admin/purchases/${orderId}/schedule-reminders`);
  },
  sendReminder: (reminderId) => {
    return apiService.post(`/admin/reminders/${reminderId}/send`);
  }
};
